export default {
    'add-currency': 'Add currency',
    'edit-currency': 'Edit currency',
    'currency-name': 'Currency name',
    'currency-symbol': 'Currency Symbol',
    'equivalent-price-with-system-currency': 'Exchange rate for main currency',
    save: 'save',
    cancel: 'cancel',
    'currency-equivalent-rate-update-record-for': 'History of exchange rate of',
    'ok': 'OK',
    'update-currency-price': 'Update exchange rate',
    'update-currency-date': 'Update date',

    'history-headers': {
        'equivalent-price-with-system-currency': 'Exchange rate for main currency',
        'update-date': 'Date of update',
    },

    headers: {
        'currency-symbol': 'Currency symbol',
        'currency-name': 'Currency name',
        'equivalent-price': 'Exchange rates',
        'actions': 'Actions',
    },
    'delete-currency': 'Delete currency',
    'are-you-sure-you-want-to-delete-the-currency': 'Are you sure you want to delete the currency ?'
}